import { InboxMultipleOutlineIcon } from './InboxMultipleOutlineIcon';

/**
 * author: Google
 * id AA22D582-9319-4AB0-BBF8-08824D7605B8
 * name inbox-multiple-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/inbox-multiple-outline.svg
 * tags
 */
export const InboxesOutlineIcon = InboxMultipleOutlineIcon;
export default InboxesOutlineIcon